import { baseApi } from './baseApi';

export const contactsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getContacts: builder.query({
      query: ({ query }) => ({
        url: `/user_contacts`,
        params: { query },
      }),
      providesTags: ['Contacts'],
    }),
  }),
});

export const { useGetContactsQuery } = contactsApi;
